// import React, { useEffect, useContext } from "react";
// import "../App.css";
// import "mdb-react-ui-kit/dist/css/mdb.min.css";
// import "@fortawesome/fontawesome-free/css/all.min.css";
// import LoginForm from "../forms/LoginForm";
// import { useNavigate } from "react-router-dom";
// import { UserContext } from "../UserContext";
// import BeforeLoginFooter from "./BeforeLoginFooter";

// function Login() {
//   const navigate = useNavigate();
//   const { isLoggedIn } = useContext(UserContext);

//   useEffect(() => {
//     if (isLoggedIn) {
//       navigate("/Dashboard");
//     }
//   }, []);

//   return (
//     <div className="container-wrapper">
//       <div>
//         <LoginForm />
//       </div>{" "}
//       <div>
//         {/* <BeforeLoginFooter /> */}
//       </div>
//     </div>
//   );
// }
// export default Login;

import React, { useEffect, useContext } from "react";
import "../App.css";
import "mdb-react-ui-kit/dist/css/mdb.min.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import LoginForm from "../forms/LoginForm";
import { useNavigate } from "react-router-dom";
import { UserContext } from "../UserContext";
import BeforeLoginFooter from "./BeforeLoginFooter";

function Login() {
  const navigate = useNavigate();
  const { isLoggedIn } = useContext(UserContext);

  useEffect(() => {
    if (isLoggedIn) {
      navigate("/Dashboard");
    }
  }, []);

  return (
    < >
      <div >
        <LoginForm />
      </div>{" "}
      <div>
        {/* <BeforeLoginFooter /> */}
      </div>
    </>
  );
}
export default Login;
